// src/utils/pluralize.ts

interface Rule {
  rule: RegExp
  template: string
}

class Pluralize {
  private static instance: Pluralize
  private readonly uncountables: Set<string>
  private readonly rules: Rule[]

  private constructor() {
    this.uncountables = new Set<string>([
      "access",
      "accommodation",
      "adulthood",
      "advertising",
      "advice",
      "aggression",
      "aid",
      "air",
      "alcohol",
      "anger",
      "applause",
      "arithmetic",
      "art",
      "assistance",
      "athletics",
      "attention",
      "bacon",
      "baggage",
      "ballet",
      "beauty",
      "beef",
      "beer",
      "biology",
      "botany",
      "bread",
      "butter",
      "carbon",
      "cash",
      "chaos",
      "cheese",
      "chess",
      "childhood",
      "clothing",
      "coal",
      "coffee",
      "commerce",
      "compassion",
      "comprehension",
      "content",
      "corruption",
      "cotton",
      "courage",
      "currency",
      "dancing",
      "danger",
      "data",
      "delight",
      "dignity",
      "dirt",
      "distribution",
      "dust",
      "economics",
      "education",
      "electricity",
      "employment",
      "engineering",
      "envy",
      "equipment",
      "ethics",
      "evidence",
      "evolution",
      "faith",
      "fame",
      "fish",
      "flour",
      "flu",
      "food",
      "freedom",
      "fuel",
      "fun",
      "furniture",
      "garbage",
      "garlic",
      "genetics",
      "gold",
      "golf",
      "gossip",
      "grammar",
      "gratitude",
      "grief",
      "ground",
      "guilt",
      "gymnastics",
      "hair",
      "happiness",
      "hardware",
      "harm",
      "hate",
      "hatred",
      "health",
      "heat",
      "height",
      "help",
      "homework",
      "honesty",
      "honey",
      "hospitality",
      "housework",
      "humour",
      "hunger",
      "hydrogen",
      "ice",
      "ice",
      "cream",
      "importance",
      "inflation",
      "information",
      "injustice",
      "innocence",
      "iron",
      "irony",
      "jealousy",
      "jelly",
      "judo",
      "karate",
      "kindness",
      "knowledge",
      "labour",
      "lack",
      "laughter",
      "lava",
      "leather",
      "leisure",
      "lightning",
      "linguistics",
      "litter",
      "livestock",
      "logic",
      "loneliness",
      "luck",
      "luggage",
      "machinery",
      "magic",
      "management",
      "mankind",
      "marble",
      "mathematics",
      "mayonnaise",
      "measles",
      "meat",
      "methane",
      "milk",
      "money",
      "mud",
      "music",
      "nature",
      "news",
      "nitrogen",
      "nonsense",
      "nurture",
      "nutrition",
      "obedience",
      "obesity",
      "oil",
      "oxygen",
      "passion",
      "pasta",
      "patience",
      "permission",
      "physics",
      "poetry",
      "pollution",
      "poverty",
      "power",
      "pronunciation",
      "psychology",
      "publicity",
      "quartz",
      "racism",
      "rain",
      "relaxation",
      "reliability",
      "research",
      "respect",
      "revenge",
      "rice",
      "rubbish",
      "rum",
      "salad",
      "satire",
      "seaside",
      "shame",
      "shopping",
      "silence",
      "sleep",
      "smoke",
      "smoking",
      "snow",
      "soap",
      "software",
      "soil",
      "sorrow",
      "soup",
      "speed",
      "spelling",
      "steam",
      "stuff",
      "stupidity",
      "sunshine",
      "symmetry",
      "tennis",
      "thirst",
      "thunder",
      "toast",
      "tolerance",
      "toys",
      "traffic",
      "transportation",
      "travel",
      "trust",
      "understanding",
      "unemployment",
      "unity",
      "validity",
      "veal",
      "vengeance",
      "violence",
    ])
    this.rules = []

    this.addRule(/$/, "s")
    this.addRule(/s$/, "ses")
    this.addRule(/(t|r|l|b)y$/, "ies")
    this.addRule(/x$/, "xes")
    this.addRule(/(sh|zz|ss)$/, "es")
    this.addRule(/(ax)is$/, "es")
    this.addRule(/(cact|nucle|alumn|bacill|fung|radi|stimul|syllab)us$/, "i")
    this.addRule(/(corp)us$/, "ora")
    this.addRule(/sis$/, "ses")
    this.addRule(/ch$/, "ches")
    this.addRule(/o$/, "os")
    this.addRule(/(buffal|carg|mosquit|torped|zer|vet|her|ech)o$/, "oes")
    this.addRule(/fe$/, "ves")
    this.addRule(/(thie)f$/, "ves")
    this.addRule(/oaf$/, "oaves")
    this.addRule(/um$/, "a")
    this.addRule(/ium$/, "ia")
    this.addRule(/oof$/, "ooves")
    this.addRule(/(nebul)a$/, "ae")
    this.addRule(/(criteri|phenomen)on$/, "a")
    this.addRule(/(potat|tomat|volcan)o$/, "oes")
    this.addRule(/^(|wo|work|fire)man$/, "men")
    this.addRule(/(f)oot$/, "eet")
    this.addRule(/lf$/, "lves")
    this.addRule(/(t)ooth$/, "eeth")
    this.addRule(/(g)oose$/, "eese")
    this.addRule(/^(c)hild$/, "hildren")
    this.addRule(/^(o)x$/, "xen")
    this.addRule(/^(p)erson$/, "eople")
    this.addRule(/(m|l)ouse$/, "ice")
    this.addRule(/^(d)ie$/, "ice")
    this.addRule(/^(alg|vertebr|vit)a$/, "ae")
    this.addRule(/^(a)lumna$/, "lumnae")
    this.addRule(/^(a)pparatus$/, "pparatuses")
    this.addRule(/^(ind)ex$/, "ices")
    this.addRule(/^(append|matr)ix$/, "ices")
    this.addRule(/^(b|tabl)eau$/, "eaux")
    this.addRule(/arf$/, "arves")
    this.addRule(/(embarg)o$/, "oes")
    this.addRule(/(gen)us$/, "era")
    this.addRule(/(r)oof$/, "oofs")
    this.addRule(/(l)eaf$/, "eaves")
    this.addRule(/(millen)ium$/, "ia")
    this.addRule(/(th)at$/, "ose")
    this.addRule(/(th)is$/, "ese")
    this.addRule(/([^aeiou])y$/, "ies")
    this.addRule(/(.*[bcdfghjklmnpqrstvwxyz])y$/, "$1ies")
    this.addRule(/([^aeiou])o$/, "$1oes")
    this.addRule(/([^aeiou])f$/, "$1ves")
    this.addRule(/^(man)$/, "men")
    this.addRule(/(child)$/, "children")
    this.addRule(/([aeiou])y$/, "$1ys")
    this.addRule(/goose$/, "geese")
    this.addRule(/([^s])s$/, "$1ses")
    this.addRule(/(quiz)$/, "$1zes")
    this.addRule(/leaf$/, "leaves")
    this.addRule(/(class)$/, "$1es")

    this.unchangingWord("sheep")
    this.unchangingWord("deer")
    this.unchangingWord("moose")
    this.unchangingWord("swine")
    this.unchangingWord("bison")
    this.unchangingWord("corps")
    this.unchangingWord("means")
    this.unchangingWord("series")
    this.unchangingWord("scissors")
    this.unchangingWord("species")
  }

  public static getInstance(): Pluralize {
    if (!Pluralize.instance) {
      Pluralize.instance = new Pluralize()
    }
    return Pluralize.instance
  }

  private addRule(rule: RegExp, template: string) {
    this.rules.unshift({ rule, template })
  }

  private unchangingWord(word: string) {
    this.uncountables.add(word.toLowerCase())
  }

  public apply(word: string): string {
    if (this.uncountables.has(word.toLowerCase()) || word.length === 0) {
      return word
    }

    for (const { rule, template } of this.rules) {
      if (rule.test(word)) {
        return word.replace(rule, template)
      }
    }

    return word
  }

  public static pluralize(
    word: string,
    count: number = 2,
    withWord: string = "",
    showCount: boolean = true
  ): string {
    const instance = Pluralize.getInstance()

    // Check if the word is uncountable
    if (instance.uncountables.has(word.toLowerCase())) {
      return word // Return just the word for uncountable nouns
    }

    if (Math.abs(count - 1) < Number.EPSILON) {
      return showCount ? `${count} ${word}` : word
    }

    // Use alternative word if provided
    if (withWord.length > 0) {
      return showCount ? `${count} ${withWord}` : withWord
    }

    // Apply rules to find the correct plural form
    const pluralForm = instance.apply(word)
    return showCount ? `${count} ${pluralForm}` : pluralForm
  }
}

export default Pluralize
